import {inject, Injectable} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {SsoUser} from '../../../app.constants';
import {map, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private oidcSecurityService = inject(OidcSecurityService);

  getUser(): Observable<SsoUser | null> {
    console.log("12314")
    return this.oidcSecurityService.userData$.pipe(
      map(userData => {
        console.log(userData)
        return userData.userData as SsoUser;
      })
    );
  }
}

